import { logSessionInfo } from "./logger";

const IPA2AMIRABET_EN_US_DOUBLE = new Map([
  ['aʊ', 'α'],
  ['aɪ', 'γ'],
  ['aI', 'γ'],
  ['tʃ', 'x'],
  ['tS', 'x'],
  ['eɪ', 'a'],
  ['eI', 'a'],
  ['dʒ', 'j'],
  ['dZ', 'j'],
  ['oʊ', 'o'],
  ['ɔɪ', 'ω']
]);

const IPA2AMIRABET_EN_US_SINGLE = new Map([
  ['̩', ''],
  ['b', 'b'],
  ['d', 'd'],
  ['f', 'f'],
  ['ɡ', 'g'],
  ['g', 'g'],
  ['h', 'h'],
  ['i', 'i'],
  ['ʤ', 'j'],
  ['k', 'k'],
  ['l', 'l'],
  ['ɫ', 'l'],
  ['m', 'm'],
  ['n', 'n'],
  ['N', 'n'],
  ['p', 'p'],
  ['s', 's'],
  ['t', 't'],
  ['u', 'u'],
  ['v', 'v'],
  ['w', 'w'],
  ['ʧ', 'x'],
  ['c', 'x'],
  ['j', 'y'],
  ['z', 'z'],
  ['æ', 'æ'],
  ['&', 'æ'],
  ['ð', 'ð'],
  ['D', 'ð'],
  ['ŋ', 'ŋ'],
  ['9', 'ŋ'],
  ['ɑ', 'ɑ'],
  ['ɒ', 'ɑ'],
  ['ɔ', 'ɔ'],
  ['ɛ', 'ɛ'],
  ['ɝ', 'ɝ'],
  ['ɚ', 'ɝ'],
  ['3', 'ɝ'],
  ['ɪ', 'ɪ'],
  ['I', 'ɪ'],
  ['ɹ', 'ɹ'],
  ['r', 'ɹ'],
  ['ʃ', 'ʃ'],
  ['S', 'ʃ'],
  ['ʊ', 'ʊ'],
  ['V', 'ʊ'],
  ['U', 'ʊ'],
  ['ʌ', 'ʌ'],
  ['ə', 'ʌ'],
  ['ʒ', 'ʒ'],
  ['Z', 'ʒ'],
  ['θ', 'θ'],
  ['T', 'θ']
]);

export function ipaToAmirabet(phon){
  let ipa = phon.replace(/\//g, "").replace(/\ˈ/g, "");
  let result = '';

  while(ipa.length > 0){
    let match = '';
    match = IPA2AMIRABET_EN_US_DOUBLE.get(ipa.substring(0,2));
    if(match){
      result += match;
      ipa = ipa.substring(2);
      continue;
    }
    match = IPA2AMIRABET_EN_US_SINGLE.get(ipa.substring(0,1));
    if(match){
      result += match;
      ipa = ipa.substring(1);
      continue;
    }
    console.log("NOT FOUND",ipa.substring(1));
    ipa = ipa.substring(1);
  }
  return result;
}

const VOWELS = [
  "ɑ",
  "ɒ",  // ɑ homophone
  "æ",
  "ʌ",
  "ə",
  "ɔ",
  "ɛ",
  "ɝ",
  "ɚ",  // AXR but Amira ARPABET combines with ER
  "ɪ",
  "i",
  "ʊ",
  "u",
];

const singlePhonemeMatches = {
  "ɑ": ["ɛ", "ʌ", "ɔ", "ɑ"],
  "ɒ": ["ɛ", "ʌ", "ɔ", "ɑ"],
  "æ": ["ɛ", "æ", "ʌ"],
  "ʌ": ["ʌ", "ɑ", "ɔ"],
  "ə": ["ʌ", "ɔ", "ɑ"],
  "ɔ": ["ɔ", "o", "ɑ", "ʌ"],
  "b": ["b", "p", "v"],
  "d": ["d", "t"],
  "ð": ["ð", "θ", "v", "f"],
  "ɛ": ["ɛ", "ɪ", "ɑ"],
  "ɝ": ["ɹ", "ɝ"],
  "f": ["v", "s", "f"],
  "ɡ": ["g", "ɡ", "k"],
  "g": ["g", "ɡ", "k"],
  "h": ["h", "p"],
  "ɪ": ["y", "ɛ", "ɪ", "i"],
  "i": ["i", "ɪ"],
  "k": ["k", "g"],
  "l": ["u", "l"],
  "m": ["m", "n"],
  "n": ["n", "m"],
  "ŋ": ["ŋ", "n"],
  "p": ["b", "h", "p"],
  "r": ["ɹ", "ɝ", "n", "r", "R"],
  "ɹ": ["ɹ", "ɝ", "n"],
  "s": ["ʃ", "s", "z"],
  "ʃ": ["s", "ʒ", "ʃ"],
  "t": ["d", "t"],
  "θ": ["ð", "θ", "f", "s"],
  "ʊ": ["ʊ", "u", "w"],
  "u": ["l", "u", "ʊ"],
  "v": ["v", "w", "f"],
  "w": ["ʊ", "w", "v"],
  "j": ["y", "ɪ"],
  "z": ["s", "z"],
  "ʒ": ["ʒ", "ʃ", "z"]
};

const multiPhonemeMatches = {
  "aʊ": ["α", "o"],
  "aɪ": ["γ"],
  "ʧ": ["j", "x", "ʤ"],
  "eɪ": ["a"],
  "ʤ": ["j", "g", "x"],
  "oʊ": ["ɔ", "ω", "α", "o"],
  "ɔɪ": ["o", "ω"],
  "kw": ["k", "g","ʊ", "w", "v"],
};

const loggingState = {
  matchFound: "phoneme_match_found",
  matchNotFound: "phoneme_match_not_found",
};

function getPossibleMatchesForPhoneme(phoneme){
  const match = singlePhonemeMatches[phoneme] || multiPhonemeMatches[phoneme] || [phoneme];
  return match;
}

export function checkPhonemeMatch(phoneme,matchString){
  if(matchString && matchString.includes(phoneme)) {
    logPhonemeData({ isMatch: true, possibleMatches: [], phoneme, matchString });
    return true;
  }
  if(!phoneme || !matchString) {
    logPhonemeData({ isMatch: false, possibleMatches: [], phoneme, matchString });
    return false;
  }

  const possibleMatches = getPossibleMatchesForPhoneme(phoneme);
  const isMatch = (possibleMatches && matchString) ? containsAnyCharacters(matchString, possibleMatches) : false;

  logPhonemeData({ isMatch, possibleMatches, phoneme, matchString });

  return isMatch;
}

// this is like checkPhonemeMatch, but it needs to be more restrictive because it is used in
//   placement manager which means it is used in jsDiff's equals function. If it is too permissive,
//   it will cause jsDiff to match multiple things to the same spoken word, which will break
//   the diff generation
export function placementPhonemeEquals(spokenWord, expectedWord){
  if(!spokenWord || !expectedWord){
    return false;
  }

  if(isPhoneme(expectedWord)){

    // for phon matching in a placement context, match if the phoneme is anywhere in the spoken
    //   "word". This is because we frequently add a ^ on accident when reading phonemes
    //   only do this for consonants since we don't have the problem of adding ^ to vowels
    if(spokenWord.length <= 2 && spokenWord.includes(expectedWord) && !isVowel(expectedWord)){ // the length limitation is necessary to keep jsdiff from matching a large chunk as a single word
      return true;
    }

    // find out whether the phoneme we are looking for is a member of a set of "equivalent" phonemes
    const phonEquivalencyArray = getPossibleMatchesForPhoneme(expectedWord);

    // if it is, check whether the spoken word matches any of the phonemes in that set
    let isEquivalencyMatch = false;
    phonEquivalencyArray.forEach((equivalentPhon) => {
      if(!isVowel(equivalentPhon) && spokenWord.length <= 2 && spokenWord.includes(equivalentPhon)){
        isEquivalencyMatch = true;
      }
      if(isVowel(equivalentPhon) && spokenWord === equivalentPhon){ //require an exact match for vowels, even when using equivalencies
        isEquivalencyMatch = true;
      }
    });

    // if we did match one of the equivalent phonemes in the set, return true because we've found a "fuzzy" match
    if(isEquivalencyMatch){
      return true;
    }

  }

  return false;
}

export function isPhoneme(word){
  const SUPPORTED_IPA_PHONEMES = Object.keys(singlePhonemeMatches)
    .concat(Object.keys(multiPhonemeMatches));
  return SUPPORTED_IPA_PHONEMES.includes(word);
}

function isVowel(word){
  return VOWELS.includes(word);
}

export function wordArrayContainsPhonemes(words){
  for(let i = 0; i < words.length; i++){
    const word = words[i]
    if(isPhoneme(word)){
      return true;
    }
  };
  return false;
}

function containsAnyCharacters(str, characters) {
  for (let char of characters) {
    if (str.includes(char)) {
      return true;
    }
  }
  return false;
}

function logPhonemeData({ isMatch, possibleMatches, matchString, phoneme }) {
  const loggingText = isMatch ? loggingState.matchFound : loggingState.matchNotFound;
  const loggingData = {
    isMatch,
    possibleMatches,
    expectedPhoneme: phoneme,
    ASRTranscript: matchString,
  };

  console.log("Check Phoneme Match", loggingData);
  logSessionInfo(loggingText, loggingData);
}